import React from "react"
import SelectionTypeForm from "./SelectionTypeForm"
import PropTypes from "prop-types"

const SelectionTypeEdit = ({ selectionTypeId = null, selectionTypes = [], ...restProps }) => {
  if (!selectionTypeId) {
    return null
  }

  const selectionType = selectionTypes.find(at => at.id.toString() === selectionTypeId.toString())

  if (!selectionType) {
    return null
  }

  return <SelectionTypeForm {...restProps} selectionType={selectionType} />
}

export default SelectionTypeEdit

SelectionTypeEdit.propTypes = {
  selectionTypeId: PropTypes.number,
  selectionTypes: PropTypes.array
}
